/* eslint-disable import/first */
import { message } from "antd";
import { actions as loadingActions } from "../../components/loading/index";
import { notification, Modal, Card } from "antd";
const { confirm } = Modal;
import React from "react";

export const stepOneSubmit = (formVal, history) => {
  
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    // 
    // 
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    const currentStep = getState().firebase.profile.profileCurrentStep;

    firestore
      .doc(`students/${uid}`)
      .set(
        {
          personalEmail: formVal.personalEmail,
          gender: formVal.gender,
          phoneNumber: formVal.phoneNumber,
          fullName: formVal.fullName,
          dob:formVal.dob,
          profileCurrentStep: currentStep ? currentStep : 0,
          profileLastUpdatedOn: new Date()
        },
        { merge: true }
      )
      .then(function () {
        dispatch({ type: "CHANGE_STEP", payload: { step: 1 } });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function (error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const stepTwoSubmit = (formVal, history) => {
 
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    const currentStep = getState().firebase.profile.profileCurrentStep;

    if(getState().firebase.profile.role=='STUDENT'){
      var data = {
        campus: formVal.campus,
        branch: formVal.branch,
        gradYear: formVal.gradYear,
        section: formVal.section,
        rollnumber: formVal.rollnumber,
        cgpa:formVal.cgpa,
        sgpa:formVal.sgpa,
        backlogs:formVal.backlogs,
        tenthgpa:formVal.tenthgpa,
        intergpa:formVal.intergpa,
        backlogshistory:formVal.backlogshistory,
        profileCurrentStep: currentStep <= 1 ? 1 : currentStep
      }
    }else{
      var data = {
        campus: formVal.campus,
        branch: formVal.branch,
        designation:formVal.designation,
        profileCurrentStep: currentStep <= 1 ? 1 : currentStep
      }
    }

    firestore
      .doc(`students/${uid}`)
      .set({...data, profileLastUpdatedOn: new Date()},
        { merge: true }
      )
      .then(function () {
        dispatch({ type: "CHANGE_STEP", payload: { step: 2 } });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function (error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const modelFromStep = (visible, loading, step, itemIndex = null) => {
  

  return (dispatch, getState, { getFirestore, getFirebase }) => {
    // 
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible,
        loading,
        step,
        itemIndex
      }
    });
  };
};

export const deleteItem = ( category, itemToDelete = null) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());

    const firestore = getFirestore();
    let data = null;
    const uid = getState().firebase.auth.uid;

      data = {
        [category + "." + itemToDelete]: firestore.FieldValue.delete(),
        [category + "Array"]: firestore.FieldValue.arrayRemove(itemToDelete)
    }

    firestore
      .doc(`students/${uid}`)
      .update(data)
      .then(function () {
        dispatch(loadingActions.hideLoading());
      })
      .catch(function (error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const stepWithSkillsSubmit = (formVal,
  
  history,
  categary,
  
  step,
  arrayField) => {

  return (dispatch, getState, { getFirestore, getFirebase }) => {
  
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible: true,
        loading: true,
        step: step
      }
    });

    if (typeof formVal.workshopDate !== "undefined") {
      // 
      formVal.workshopDate = formVal.workshopDate.toString();
    }
    if (typeof formVal.internshipDate !== "undefined") {
      formVal.internshipDate = formVal.internshipDate.toString();
    }
    if (typeof formVal.publicationDate !== "undefined") {
      formVal.publicationDate = formVal.publicationDate.toString();
    }
    if (typeof formVal.certificationDate !== "undefined") {
      formVal.certificationDate = formVal.certificationDate.toString();
    }
    if (typeof formVal.hackathonDate !== "undefined") {
      formVal.hackathonDate = formVal.hackathonDate.toString();
    }
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    let data = {
      
    };

    data[
      categary
    ] = {
        [formVal[arrayField]]: {
          ...formVal,
          createdOn: new Date().toLocaleDateString(),
        }
      }

    data[[categary + "Array"]] = firestore.FieldValue.arrayUnion(formVal[arrayField])

    firestore
      .doc(`students/${uid}`)
      .set({...data, profileLastUpdatedOn: new Date()}, { merge: true })
      .then(function (doc) {
        
        dispatch({
          type: "HIDE_MODEL_FROM_STEP",
          payload: {
            visible: false,
            loading: false,
            step: step
          }
        });
      })
      .catch(function (error) {
        message.error(
          "Something went wrong. Please refresh the page and try again" +
          error
        );
      });

  }
}

export const stepCpVerify = (
  formVal,
  history,
  categary,
  step,
  itemIndex = null
) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    // 
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible: true,
        loading: true,
        step: step,
        itemIndex: itemIndex
      }
    });

    fetch(
      `https://us-central1-vedicplatform.cloudfunctions.net/userProfileValidateApi/${formVal.cpWebsiteName}/${formVal.cpWebsiteUserName}`,
      { mode: "cors" }
    )
      .then(response => response.json())
      .then(resData => {
        if (!resData.valid) {
          dispatch({
            type: "HIDE_MODEL_FROM_STEP",
            payload: {
              visible: true,
              loading: false,
              step: step,
              itemIndex: itemIndex
            }
          });
          notification.error({
            message: "Notification Title",
            duration: 5,
            description: `"${formVal.cpWebsiteUserName} Not found on ${formVal.cpWebsiteName}. Do recheck the username you entering`
          });
        } else {
          const firestore = getFirestore();
          const uid = getState().firebase.auth.uid;
          confirm({
            title: `Can you confirm Username "${formVal.cpWebsiteUserName}" belongs to you on ${formVal.cpWebsiteName} ?`,
            content: (
              <Card style={{ width: 300 }}>
                <p>Username/Name from website: {resData.title} </p>
              </Card>
            ),
            onOk() {
              let data = {
                // profileCurrentStep: step
              };

              data[
                "programmingWebsitesProfiles"
              ] = {
                  [formVal.cpWebsiteName]: {
                    userName: formVal.cpWebsiteUserName
                  }
                }

                data[
                  "programmingWebsitesProfilesArray"
                ] = firestore.FieldValue.arrayUnion(formVal.cpWebsiteName)

              // firestore.FieldValue.arrayUnion(formVal);
              firestore
                .doc(`students/${uid}`)
                .set({...data, profileLastUpdatedOn: new Date()}, { merge: true })
                .then(function () {
                  dispatch({
                    type: "HIDE_MODEL_FROM_STEP",
                    payload: {
                      visible: false,
                      loading: false,
                      step: step,
                      itemIndex: itemIndex
                    }
                  });
                  message.success("Successfully added");
                })
                .catch(function (error) {
                  dispatch({
                    type: "HIDE_MODEL_FROM_STEP",
                    payload: {
                      visible: false,
                      loading: false,
                      step: step,
                      itemIndex: itemIndex
                    }
                  });
                  // 
                  message.error(
                    "Something went wrong. Please refresh the page and try again" +
                    error
                  );
                });
            },
            onCancel() {
              dispatch({
                type: "HIDE_MODEL_FROM_STEP",
                payload: {
                  visible: true,
                  loading: false,
                  step: step,
                  itemIndex: itemIndex
                }
              });
            }
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: "HIDE_MODEL_FROM_STEP",
          payload: {
            visible: false,
            loading: false,
            step: step,
            itemIndex: itemIndex
          }
        });
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });

    //dispatch(loadingActions.showLoading());
    // dispatch({type:'HIDE_MODEL_FROM_STEP', payload: {visible: true,loading:true,step:step}})
  };
};

export const goToStep = (step, history) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    const currentStep = getState().firebase.profile.profileCurrentStep;
    firestore
      .doc(`students/${uid}`)
      .set(
        {
          profileCurrentStep: currentStep <= step ? step : currentStep
        },
        { merge: true }
      )
      .then(function () {
        dispatch(loadingActions.hideLoading());
        dispatch({
          type: "CHANGE_STEP",
          payload: { step: step < 11 ? step + 1 : 11 }
        });
        if (step == 11) history.push(`/home/profile/${uid}`);
      })
      .catch(function (error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const changeStep = (step, history) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const currentStep = getState().firebase.profile.profileCurrentStep;
    // 
    if (step <= currentStep + 1) {
      if (currentStep === -1) {
        dispatch({ type: "CHANGE_STEP", payload: { step: 0 } });
      } else {
        dispatch({ type: "CHANGE_STEP", payload: { step: step } });
      }
    } else {
      message.error(
        "Please complete previous steps and proceed to Step" + (step + 1)
      );
    }

    // 
  };
};
